import React from 'react';

function CardIcon() {
  return (
    <svg width="58" height="40" viewBox="0 0 58 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 13.2945C15 12.4207 15.3471 11.5828 15.9649 10.9649C16.5828 10.3471 17.4207 10 18.2945 10H39.7055C40.5793 10 41.4172 10.3471 42.0351 10.9649C42.6529 11.5828 43 12.4207 43 13.2945V13.4995H15V13.2945ZM15 17.0003V26.4699C15 26.9026 15.0852 27.331 15.2508 27.7307C15.4163 28.1304 15.659 28.4936 15.9649 28.7995C16.2708 29.1054 16.634 29.3481 17.0337 29.5136C17.4334 29.6792 17.8618 29.7644 18.2945 29.7644H39.7055C40.1382 29.7644 40.5666 29.6792 40.9663 29.5136C41.366 29.3481 41.7292 29.1054 42.0351 28.7995C42.341 28.4936 42.5837 28.1304 42.7492 27.7307C42.9148 27.331 43 26.9026 43 26.4699V17.0003H15ZM18.4995 25.7498C18.4995 24.7838 19.2839 23.9994 20.2499 23.9994H22.0003C22.4645 23.9994 22.9098 24.1838 23.238 24.5121C23.5663 24.8403 23.7507 25.2855 23.7507 25.7498C23.7507 26.214 23.5663 26.6592 23.238 26.9875C22.9098 27.3157 22.4645 27.5002 22.0003 27.5002H20.2499C20.0201 27.5002 19.7924 27.4549 19.5801 27.3669C19.3677 27.2789 19.1748 27.15 19.0122 26.9875C18.8497 26.8249 18.7207 26.632 18.6328 26.4196C18.5448 26.2072 18.4995 25.9796 18.4995 25.7498Z"
        fill="#4F5B76"
      />
    </svg>
  );
}

export default CardIcon;
